<template>
<div>
  <group-card title="Storage Log" icon="library_books" padded>
    <md-dialog-content>
      <div class="md-layout input-layout">
        <div class="md-layout-item input-layout md-small-size-25 md-size-25">
          <validated-number-input
            class="md-layout-item md-small-size-100 md-size-100"
            label="Find Logs by Application ID"
            v-model="loan_app_log_id"
            errormsg="Storage Log ID must be numbers."
          >
          </validated-number-input>
          <md-dialog-actions class="show-list-button">
            <loading-icon-text-button
              @click="getStorageLogList('searchByAppId')"
              icon="search"
              :loading="loading"
            >
              Run
            </loading-icon-text-button>
          </md-dialog-actions>
        </div>
        <div class="md-layout-item input-layout md-small-size-25 md-size-25">
          <validated-number-input
            class="md-layout-item md-small-size-100 md-size-100"
            label="Find Log by Storage ID"
            v-model="storage_log_id"
            errormsg="Storage Log ID must be numbers."
          >
          </validated-number-input>

          <md-dialog-actions class="show-list-button">
            <loading-icon-text-button
              @click="getStorageLogList('searchByStorageId')"
              icon="search"
              :loading="loadingB2"
            >
              Run
            </loading-icon-text-button>
          </md-dialog-actions>
        </div>
      </div>
      <div
        v-if="storage_log.length > 0"
        class="table-container"
      >
        <table class="data-table wide">
          <thead>
            <tr>
              <th>Time</th>
              <th>User</th>
              <th>Caller</th>
              <th>Content</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="log in storage_log">
              <td>{{ (log.date ? log.date : Date()) | datetime }}</td>
              <td>{{ log.user }}</td>
              <td>{{ log.caller }}</td>
              <td>
                <v-btn

                  color="#005596"
                  outlined
                  small
                  @click="showContent(log.id)"
                >
                See Log
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </md-dialog-content>
  </group-card>
</div>
</template>
<script>
import GroupCard from "../components/Cards/GroupCard";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import GroupCardRow from "../components/Cards/GroupCardRow";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import AlertDialog from "../components/Dialogs/AlertDialog";
import ValidatedNumberInput from "../components/ValidatedInput/ValidatedNumberInput";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";

export default {
  components: {
    ValidatedNumberInput,
    LoadingIconTextButton,
    GroupCard,
    GroupCardRow,
    AlertDialog,
  },
  data() {
    return {
      loan_app_log_id: null,
      storage_log_id: null,
      loading: false,
      loadingB2: false,
      storage_log: [],
    };
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    async showContent(id) {
      try {
        const response = await axios.get(`/api/v1/administration/getStorageLogDetails/${id}`);

        this.$modal.show(ConfirmDialog, {
          title: 'Message',
          message: response.data.data,
          confirmText: 'Ok',
        });
      } catch(error) {
        console.log(error);
        this.showNotification("Failed to Retrieve Log.", "Error!");
        return;
      }
    },
    async getStorageLogList(type) {
      this.storage_log = [];

      let searchByAppId = false;
      let id;
      if (type == 'searchByAppId') {
        searchByAppId = true;
        if (!this.loan_app_log_id) {
          this.showNotification("Application ID is required", "Error!");
          return;
        }
        //if application id is not number show error
        if (isNaN(this.loan_app_log_id)) {
          this.showNotification("Application ID must be numbers.", "Error!");
          return;
        }
        id = this.loan_app_log_id
        this.loading = true;
      } else {
        if (!this.storage_log_id) {
          this.showNotification("Storage ID is required", "Error!");
          return;
        }
        //if application id is not number show error
        if (isNaN(this.storage_log_id)) {
          this.showNotification("Storage ID must be numbers.", "Error!");
          return;
        }
        id = this.storage_log_id
        this.loadingB2 = true;
      }
      try {
        const response = await axios.post(`/api/v1/administration/getStorageLogList/${id}`,
          {'searchByAppId': searchByAppId});


        if (response.status == 500) {
          this.showNotification("Failed to Retrieve Log.", "Error!");
          return;
        }
        this.storage_log = response.data;
      } catch(error) {
        console.log(error);
        this.showNotification("Failed to Retrieve Log.", "Error!");
      }
      this.loading = false;
      this.loadingB2 = false;
    },
    showNotification(message, title) {
      if (this.$modal.submit) {
        this.$modal.submit();
      }
      this.$modal.show(AlertDialog, {
        title: title,
        message: message,
      });
      this.loading = false;
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
}
</script>
<style scoped>
.md-card img {
 width: 20% !important;
}
</style>
